/** Presentation follows the actual age names, independently of balance bands. */
export const VISUAL_AGES = [
  { id: 'steppe', era: 0, transport: 'person', attack: 'melee' },
  { id: 'gokturk', era: 1, transport: 'horse', attack: 'arrow' },
  { id: 'seljuk', era: 2, transport: 'cart', attack: 'arrow' },
  { id: 'ottoman', era: 2, transport: 'cart', attack: 'cannon' },
  { id: 'republic', era: 3, transport: 'truck', attack: 'rifle' },
  { id: 'space', era: 4, transport: 'rover', attack: 'plasma' },
  { id: 'planet', era: 4, transport: 'drone', attack: 'plasma' },
  { id: 'star', era: 4, transport: 'drone', attack: 'beam' },
  { id: 'galaxy', era: 4, transport: 'shuttle', attack: 'beam' },
  { id: 'cosmic', era: 4, transport: 'shuttle', attack: 'beam' },
  { id: 'sky', era: 4, transport: 'energy', attack: 'beam' },
  { id: 'eternal', era: 4, transport: 'energy', attack: 'beam' },
] as const;
export function visualAge(age: number): number {
  return Math.max(0, Math.min(VISUAL_AGES.length - 1, Number.isFinite(age) ? Math.floor(age) : 0));
}
export function ageVisual(age: number) { return VISUAL_AGES[visualAge(age)]; }
export function visualEraIndex(age: number): number { return ageVisual(age).era; }
export type WorkerVehicle = typeof VISUAL_AGES[number]['transport'];
